import { inject, Injectable } from '@angular/core';
import { KindeAuthService } from '../../services/kinde-auth.service';

declare global {
  interface Window {
    SZWidget?: {
      init(config: any): void;
      setToken(token: string): void;
      open(): void;
      close(): void;
      destroy(): void;
    };
  }
}

@Injectable({ providedIn: 'root' })
export class WidgetService {
  private initialized = false;
  private kindeAuth = inject(KindeAuthService);

  async init() {
    if (this.initialized || !window.SZWidget) return;

    window.SZWidget.init({
      apiUrl: 'https://api.statementzen.com',
      position: 'bottom-right',
      theme: 'auto',
      mode: 'support',
      greeting: 'Hi! Need help with anything? I can assist with uploading statements, matching, ERP connections, and more.',
    });

    this.initialized = true;

    // Pass token if user is already logged in
    await this.setTokenFromKinde();
  }

  async setTokenFromKinde() {
    const token = await this.kindeAuth.getToken();
    if (token && window.SZWidget) {
      window.SZWidget.setToken(token);
    }
  }

  setToken(token: string) {
    if (window.SZWidget) {
      window.SZWidget.setToken(token);
    }
  }
}
